module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-09-024ca0c873baf97284482b12a2d093dd.jpg";